import { AuditAudio } from '@mi-front/core';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import React from 'react';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../api';
import { RowAction } from '../../../components/table/RowAction';
import { useUrlMediaPlayerCtx } from '../../../core/media-player/useUrlMediaPlayer';
import { mimeType } from '../../../helpers/utils';

export function AuditMediaPlayerAction({
  audio,
  ActionComponent = RowAction,
}: {
  audio: Pick<AuditAudio, 'stationId' | 'customId' | 'filename'>;
  ActionComponent?: React.ComponentType<any>;
}) {
  const ctx = useUrlMediaPlayerCtx();
  const { $t } = useIntl();

  return (
    <ActionComponent
      title={$t({
        id: 'audit.mediaPlayer.viewMedia',
        defaultMessage: 'Ver media',
      })}
      onClick={() => {
        const url = apiClient.audit.getDownloadAudioUrl({
          stationId: audio.stationId!,
          customId: audio.customId,
        });

        ctx.play(url, {
          title: audio.customId,
          type: mimeType(audio.filename),
        });
      }}
    >
      <OndemandVideoIcon />
    </ActionComponent>
  );
}
